var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8",
    "data-name": "Group 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.539,
    height: 93.462,
    viewBox: "0 0 97.539 93.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M0,17.692A17.693,17.693,0,1,1,20.959,35.079V33a15.649,15.649,0,1,0-3.267.345c.362,0,.721-.016,1.077-.041v2.047c-.357.021-.715.037-1.077.037A17.713,17.713,0,0,1,0,17.692Zm16.8,8.094V18.817H9.6V16.775h7.2V9.6h2.042v7.176h6.944v2.042H18.842v6.969Z",
    fill: "#006729"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23_Copy",
    "data-name": "Group 23 Copy",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M44.231,0A44.231,44.231,0,1,1,0,44.231,44.231,44.231,0,0,1,44.231,0Z",
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#65a518",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tiempo_01",
    "data-name": "Tiempo 01",
    transform: "translate(47.21 47.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18290",
    "data-name": "Grupo 18290",
    transform: "translate(-28.21 -28.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18289",
    "data-name": "Grupo 18289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8025",
    "data-name": "Trazado 8025",
    d: "M13.837,18.216c-.422.1-.85.2-1.275.277a2.049,2.049,0,1,0,.746,4.03c.506-.094,1.018-.206,1.519-.331a2.049,2.049,0,1,0-.99-3.977Z",
    transform: "translate(16.81 28.04)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8026",
    "data-name": "Trazado 8026",
    d: "M18.363,9.832a2.049,2.049,0,1,0,3.891-1.288c-.16-.491-.341-.982-.532-1.461a2.05,2.05,0,1,0-3.807,1.524C18.075,9.01,18.225,9.422,18.363,9.832Z",
    transform: "translate(27.441 8.949)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8027",
    "data-name": "Trazado 8027",
    d: "M15.958,17.235c-.361.239-.735.468-1.109.687a2.049,2.049,0,1,0,2.048,3.55c.445-.257.891-.532,1.321-.817a2.049,2.049,0,0,0-2.26-3.42Z",
    transform: "translate(21.347 26.095)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8028",
    "data-name": "Trazado 8028",
    d: "M22.519,10.826a2.05,2.05,0,0,0-4.1.163c.018.433.023.87.013,1.3a2.049,2.049,0,1,0,4.1.089C22.544,11.867,22.539,11.342,22.519,10.826Z",
    transform: "translate(28.451 13.68)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8029",
    "data-name": "Trazado 8029",
    d: "M20.4,15.16a2.048,2.048,0,0,0-2.87.41c-.26.346-.534.69-.814,1.018a2.054,2.054,0,0,0,.232,2.891c.048.041.1.079.15.115a2.05,2.05,0,0,0,2.74-.346c.333-.394.662-.8.972-1.219A2.047,2.047,0,0,0,20.4,15.16Z",
    transform: "translate(25.066 22.778)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8030",
    "data-name": "Trazado 8030",
    d: "M20.953,12.055A2.049,2.049,0,0,0,18.386,13.4c-.13.415-.275.827-.427,1.234a2.049,2.049,0,0,0,.733,2.4,2.006,2.006,0,0,0,.45.239,2.048,2.048,0,0,0,2.646-1.183c.183-.483.354-.977.509-1.468A2.048,2.048,0,0,0,20.953,12.055Z",
    transform: "translate(27.528 18.473)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8031",
    "data-name": "Trazado 8031",
    d: "M21.7,46.551a21.252,21.252,0,0,1-5.257-1.672l-.059-.031c-.394-.186-.786-.384-1.165-.59l-.005,0a21.962,21.962,0,0,1-2.041-1.275,21.388,21.388,0,0,1,.089-35.035l.074-.051A21.426,21.426,0,0,1,37.353,7.7l-1.6,2.313c-.445.644-.17,1.114.608,1.043l6.957-.623a1.145,1.145,0,0,0,1.038-1.5l-1.87-6.73c-.209-.753-.743-.845-1.188-.2L39.689,4.325A25.31,25.31,0,0,0,21.14.381c-.656.112-1.3.252-1.941.415l-.013,0-.074.02A25.276,25.276,0,0,0,5.1,10.211a1.135,1.135,0,0,0-.087.107c-.117.158-.234.318-.346.478-.186.262-.366.532-.542.8-.02.031-.038.064-.056.1A25.3,25.3,0,0,0,.026,26.6a.375.375,0,0,1,0,.053c.023.514.064,1.036.12,1.547,0,.033.01.066.015.1.059.517.13,1.033.219,1.55A25.291,25.291,0,0,0,7.514,43.567l.025.028.01.008a25.812,25.812,0,0,0,3.265,2.73A25.289,25.289,0,0,0,20.98,50.587a2.05,2.05,0,0,0,.723-4.036Z",
    transform: "translate(0 0)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8032",
    "data-name": "Trazado 8032",
    d: "M10.532,3.511A1.659,1.659,0,0,0,8.873,5.17V21.691L23.985,29.5a1.628,1.628,0,0,0,.758.186,1.657,1.657,0,0,0,.763-3.13L12.188,19.674V5.17A1.657,1.657,0,0,0,10.532,3.511Z",
    transform: "translate(13.705 5.422)",
    fill: "#006729"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(62.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-2",
    "data-name": "Oval",
    d: "M13.885,33.615A16.808,16.808,0,1,0,13.885,0C4.6,0-3.371,7.525-3.371,16.808S4.6,33.615,13.885,33.615Z",
    transform: "translate(4.691 1.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons_Add_Circle_",
    "data-name": "Icons/Add Circle "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icons_Add_Circle_background",
    "data-name": "Icons/Add Circle  background",
    width: 35.385,
    height: 35.385,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue",
    "data-name": "Color/Liberty Blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M0,17.692A17.693,17.693,0,1,1,20.959,35.079V33a15.649,15.649,0,1,0-3.267.345c.362,0,.721-.016,1.077-.041v2.047c-.357.021-.715.037-1.077.037A17.713,17.713,0,0,1,0,17.692Zm16.8,8.094V18.817H9.6V16.775h7.2V9.6h2.042v7.176h6.944v2.042H18.842v6.969Z",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-2",
    "data-name": "Color/Liberty Blue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-3",
    "data-name": "Color/Liberty Blue",
    transform: "translate(-56.026 -56.026)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 147.436,
    height: 147.436,
    fill: "#006729"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e96df938c2320cd82e7fac3953ff5cc1.svg";
export { ForwardRef as ReactComponent };